import React from 'react';
import Accordion from "react-bootstrap/Accordion";

const App4 = () => {

    return (
        <div className="DocumentLinksPage__content-container">
            <h2>Особые права (льготы)</h2>
            <p>
                Право на прием на обучение в пределах особой квоты имеют дети-инвалиды, инвалиды I и II групп, инвалиды
                с
                детства,
                инвалиды вследствие военной травмы или заболевания, полученных в период прохождения военной службы,
                дети-сироты и дети,
                оставшиеся без попечения родителей, а также лица из числа детей-сирот и детей, оставшихся без попечения
                родителей, и ветераны
                боевых действий из числа лиц, указанных в подпунктах 1 - 4 пункта 1 статьи 3 Федерального закона от 12
                января 1995 г. № 5-ФЗ
                «О ветеранах».
            </p>
            <p>
                Право на прием на обучение в пределах особой квоты также имеют лица, признанные инвалидами I, II или III
                группы после получения
                высшего образования, которые вправе повторно получить высшее образование соответствующего уровня по
                другой
                специальности или
                направлению подготовки за счет ассигнований федерального бюджета.
            </p>
            <h6>Особые права при приёме на обучение для участников СВО и их детей</h6>
            <p>
                Федеральным законом от 29 декабря 2012 г. № 273-ФЗ «Об образовании в Российской Федерации» предусмотрены
                особые права (льготы) при приёме на обучение по программам бакалавриата и специалитета <b>для участников
                СВО и их детей</b>, в том числе право на приём за счёт бюджетных ассигнований в рамках отдельной
                квоты.<br/>
                Льготы для поступления детей участников СВО в том числе распространяются на неродных усыновлённых детей.
                Отнесение к категориям лиц, имеющих право на поступление в рамках отдельной квоты, подтверждается
                соответствующей справкой, предоставляемой в установленном порядке.
            </p>
            <h5 style={{textAlign: "center"}}>Особая квота</h5>
            <table>
                <thead>
                <tr>
                    <th>№</th>
                    <th>Категория</th>
                    <th>Подтверждающий документ</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>1.</td>
                    <td>Дети-сироты<br/>
                        - Возраст поступающего до 18 лет<br/>
                        - Возраст поступающего до 23 лет, т.е. ему не исполнилось 23 года на день завершения приема
                        документов!
                    </td>
                    <td rowSpan="2">
                        - Документ, подтверждающий статус ребенка-сироты, ребенка оставшегося без попечения родителей
                        (для лиц до 18 лет)<br/><br/>
                        - Документы, подтверждающие, что до 18 лет поступающий имел статус ребенка-сироты, ребенка
                        оставшегося без попечения родителей (для лиц до 23 лет)
                    </td>
                </tr>
                <tr>
                    <td>2.</td>
                    <td>Дети, оставшиеся без попечения родителей</td>
                </tr>
                <tr>
                    <td>3.</td>
                    <td>Инвалиды:<br/>
                        - ребенок инвалид (до 18 лет)<br/>
                        - инвалид I группы<br/>
                        - инвалид II группы<br/>
                        - инвалид с детства:<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;Причины инвалидности - I группа<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;- II группа<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;- III группа<br/>
                        - инвалид вследствие военной травмы или заболевания полученных в период прохождения военной
                        службы:<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;Причины инвалидности - I группа<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;- II группа<br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;- III группа
                    </td>
                    <td>Справка об инвалидности должна быть действительна на день завершения приема документов.</td>
                </tr>
                <tr>
                    <td>4.</td>
                    <td>Ветераны боевых действий</td>
                    <td>Удостоверение ветерана боевых действий из числа лиц, указанных в подпунктах 1-4 пункта 1 статьи
                        3 ФЗ «О ветеранах».
                    </td>
                </tr>
                </tbody>
            </table>

            <h5 style={{textAlign: "center"}}>Отдельная квота</h5>
            <table>
                <thead>
                <tr>
                    <th>№</th>
                    <th>Категория</th>
                    <th>Подтверждающий документ</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>1</td>
                    <td>Герои России и граждане, награждённые тремя орденами Мужества, в том числе во время специальной
                        военной операции (СВО)
                    </td>
                    <td rowSpan="2">Справка, о том, что поступающий относится к числу (детей) военнослужащих или
                        сотрудников, подтверждающая право на прием в пределах отдельной квоты, выданная уполномоченным
                        государственным органом.
                    </td>
                </tr>
                <tr>
                    <td>2</td>
                    <td>Военнослужащие и сотрудники силовых ведомств, участвовавшие в СВО или боевых действиях на
                        территории других государств, или их дети
                    </td>
                </tr>
                </tbody>
            </table>

            <Accordion>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Количество мест</Accordion.Header>
                    <Accordion.Body><p>
                        Квота приема данных лиц, имеющих особое право, устанавливается организацией высшего образования
                        в
                        размере
                        не менее чем 10% общего объема контрольных цифр, выделенных организации высшего образования на
                        очередной год,
                        по каждой специальности и (или) направлению подготовки. <br/>
                        <a href="/pdf/Number_of_special_quota_places.pdf">Количество мест в пределах особой (отдельной)
                            квоты приема на обучение по программам бакалавриата и
                            специалитета на 2025-2026 учебный год</a>.
                    </p></Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>Преимущественное право зачисления</Accordion.Header>
                    <Accordion.Body>
                        <p>
                            <p>
                                <b>Преимущественное право</b> — один из видов особого права. Оно
                                срабатывает, когда у двух абитуриентов полностью совпадают баллы
                                в ранжированном списке. Тогда абитуриент, у которого есть
                                преимущественное право, встает в ранжированном списке на одну
                                строку выше другого.{" "}
                            </p>
                            <h6>
                                Преимущественное право зачисления при условии успешного
                                прохождения вступительных испытаний и при прочих равных условиях
                                предоставляется лицам: лицам:
                            </h6>
                            <ul style={{listStyle: "decimal"}}>
                                <li>
                                    дети-сироты и дети, оставшиеся без попечения родителей, а
                                    также лица из числа детей-сирот и детей, оставшихся без
                                    попечения родителей;
                                </li>
                                <li>дети-инвалиды, инвалиды I и II групп;</li>
                                <li>
                                    граждане в возрасте до двадцати лет, имеющие только одного
                                    родителя - инвалида I группы, если среднедушевой доход семьи
                                    ниже величины <b>прожиточного минимума</b>, установленного в
                                    субъекте Российской Федерации по месту жительства указанных
                                    граждан;
                                </li>
                                <li>
                                    граждане, которые подверглись воздействию радиации вследствие
                                    катастрофы на Чернобыльской АЭС и на которых распространяется
                                    действие Закона Российской Федерации от 15 мая 1991 г. N
                                    1244-1 "О социальной защите граждан, подвергшихся воздействию
                                    радиации вследствие катастрофы на Чернобыльской АЭС";
                                </li>
                                <li>
                                    дети военнослужащих, погибших при исполнении ими обязанностей
                                    военной службы или умерших вследствие увечья (ранения, травмы,
                                    контузии) либо заболеваний, полученных ими при исполнении
                                    обязанностей военной службы, в том числе при участии в
                                    проведении контртеррористических операций и (или) иных
                                    мероприятий по борьбе с терроризмом;
                                </li>
                                <li>
                                    дети умерших (погибших) Героев Советского Союза, Героев
                                    Российской Федерации и полных кавалеров ордена Славы;
                                </li>
                                <li>
                                    дети сотрудников органов внутренних дел, Федеральной службы
                                    войск национальной гвардии Российской Федерации, учреждений и
                                    органов уголовно-исполнительной системы, федеральной
                                    противопожарной службы Государственной противопожарной службы,
                                    органов по контролю за оборотом наркотических средств и
                                    психотропных веществ, таможенных органов, Следственного
                                    комитета Российской Федерации, погибших (умерших) вследствие
                                    увечья или иного повреждения здоровья, полученных ими в связи
                                    с выполнением служебных обязанностей, либо вследствие
                                    заболевания, полученного ими в период прохождения службы в
                                    указанных учреждениях и органах, и дети, находившиеся на их
                                    иждивении;
                                </li>
                                <li>
                                    дети прокурорских работников, погибших (умерших) вследствие
                                    увечья или иного повреждения здоровья, полученных ими в период
                                    прохождения службы в органах прокуратуры либо после увольнения
                                    вследствие причинения вреда здоровью в связи с их служебной
                                    деятельностью;
                                </li>
                                <li>
                                    военнослужащие, которые проходят военную службу по контракту,
                                    и непрерывная продолжительность военной службы по контракту
                                    которых составляет не менее трех лет, а также граждане,
                                    прошедшие военную службу по призыву и поступающие на обучение
                                    по рекомендациям командиров, выдаваемым гражданам в порядке,
                                    установленном федеральным органом исполнительной власти, в
                                    котором федеральным законом предусмотрена военная служба;
                                </li>
                                <li>
                                    граждане, проходившие в течение не менее трех лет военную
                                    службу по контракту в Вооруженных Силах Российской Федерации,
                                    других войсках, воинских формированиях и органах на воинских
                                    должностях и уволенные с военной службы по основаниям,
                                    предусмотренным подпунктами "б" - "г" пункта 1, подпунктом "а"
                                    пункта 2 и подпунктами "а" - "в" пункта 3 статьи 51
                                    Федерального закона от 28 марта 1998 г. N 53-ФЗ "О воинской
                                    обязанности и военной службе";
                                </li>
                                <li>
                                    инвалиды войны, участники боевых действий, а также ветераны
                                    боевых действий из числа лиц, указанных в подпунктах 1 - 4
                                    пункта 1 статьи 3 Федерального закона от 12 января 1995 г. N
                                    5-ФЗ "О ветеранах";
                                </li>
                                <li>
                                    граждане, непосредственно принимавшие участие в испытаниях
                                    ядерного оружия, боевых радиоактивных веществ в атмосфере,
                                    ядерного оружия под землей, в учениях с применением таких
                                    оружия и боевых радиоактивных веществ до даты фактического
                                    прекращения указанных испытаний и учений, непосредственные
                                    участники ликвидации радиационных аварий на ядерных установках
                                    надводных и подводных кораблей и других военных объектах,
                                    непосредственные участники проведения и обеспечения работ по
                                    сбору и захоронению радиоактивных веществ, а также
                                    непосредственные участники ликвидации последствий этих аварий
                                    (военнослужащие и лица из числа вольнонаемного состава
                                    Вооруженных Сил Российской Федерации, военнослужащие
                                    внутренних войск Министерства внутренних дел Российской
                                    Федерации, военнослужащие и сотрудники Федеральной службы
                                    войск национальной гвардии Российской Федерации, лица,
                                    проходившие службу в железнодорожных войсках и других воинских
                                    формированиях, сотрудники органов внутренних дел Российской
                                    Федерации и федеральной противопожарной службы Государственной
                                    противопожарной службы);
                                </li>
                                <li>
                                    военнослужащие, сотрудники Федеральной службы войск
                                    национальной гвардии Российской Федерации, органов внутренних
                                    дел Российской Федерации, уголовно-исполнительной системы,
                                    федеральной противопожарной службы Государственной
                                    противопожарной службы, выполнявшие задачи в условиях
                                    вооруженного конфликта в Чеченской Республике и на прилегающих
                                    к ней территориях, отнесенных к зоне вооруженного конфликта, и
                                    указанные военнослужащие, выполняющие задачи в ходе
                                    контртеррористических операций на территории
                                    Северо-Кавказского региона.
                                </li>
                                <li>
                                    Герои Российской Федерации, лица, награжденные тремя орденами
                                    Мужества;
                                </li>
                                <li>
                                    граждане и их дети, проходящие (проходившие) военную службу в
                                    Вооруженных Силах Российской Федерации, граждане, проходящие
                                    (проходившие) военную службу (службу) в войсках национальной
                                    гвардии Российской Федерации, в воинских формированиях и
                                    органах, указанных в пункте 6 статьи 1 Федерального закона от
                                    31 мая 1996 года <b>N 61-ФЗ "Об обороне"</b>, при условии их
                                    участия в специальной военной операции на территориях Украины,
                                    Донецкой Народной Республики, Луганской Народной Республики,
                                    Запорожской области и Херсонской области и (или) выполнения
                                    ими задач по отражению вооруженного вторжения на территорию
                                    Российской Федерации, в ходе вооруженной провокации на
                                    Государственной границе Российской Федерации и приграничных
                                    территориях субъектов Российской Федерации, прилегающих к
                                    районам проведения специальной военной операции на территориях
                                    Украины, Донецкой Народной Республики, Луганской Народной
                                    Республики, Запорожской области и Херсонской области,
                                    находящиеся (находившиеся) на указанных территориях служащие
                                    (работники) правоохранительных органов Российской Федерации,
                                    граждане, выполняющие (выполнявшие) служебные и иные
                                    аналогичные функции на указанных территориях;
                                </li>
                                <li>
                                    граждане и их дети, призванные на военную службу по
                                    мобилизации в Вооруженные Силы Российской Федерации, граждане,
                                    заключившие контракт о добровольном содействии в выполнении
                                    задач, возложенных на Вооруженные Силы Российской Федерации
                                    или войска национальной гвардии Российской Федерации, при
                                    условии их участия в специальной военной операции на
                                    территориях Украины, Донецкой Народной Республики, Луганской
                                    Народной Республики, Запорожской области и Херсонской области
                                    и (или) выполнения ими задач по отражению вооруженного
                                    вторжения на территорию Российской Федерации, в ходе
                                    вооруженной провокации на Государственной границе Российской
                                    Федерации и приграничных территориях субъектов Российской
                                    Федерации, прилегающих к районам проведения специальной
                                    военной операции на территориях Украины, Донецкой Народной
                                    Республики, Луганской Народной Республики, Запорожской области
                                    и Херсонской области, граждане, заключившие контракт (имевшие
                                    иные правоотношения) с организацией, содействующей выполнению
                                    задач, возложенных на Вооруженные Силы Российской Федерации,
                                    при условии их участия в специальной военной операции на
                                    указанных территориях;
                                </li>
                                <li>
                                    лица и их дети, принимавшие в соответствии с решениями органов
                                    государственной власти Донецкой Народной Республики, Луганской
                                    Народной Республики участие в боевых действиях в составе
                                    Вооруженных Сил Донецкой Народной Республики, Народной милиции
                                    Луганской Народной Республики, воинских формирований и органов
                                    Донецкой Народной Республики и Луганской Народной Республики
                                    начиная с 11 мая 2014 года;
                                </li>
                                <li>
                                    дети военнослужащих, сотрудников федеральных органов
                                    исполнительной власти и федеральных государственных органов, в
                                    которых федеральным законом предусмотрена военная служба,
                                    сотрудников органов внутренних дел Российской Федерации,
                                    сотрудников уголовно-исполнительной системы Российской
                                    Федерации, направленных в другие государства органами
                                    государственной власти Российской Федерации и принимавших
                                    участие в боевых действиях при исполнении служебных
                                    обязанностей в этих государствах;
                                </li>
                                <li>
                                    выпускникам общеобразовательных организаций, профессиональных
                                    образовательных организаций, находящихся в ведении федеральных
                                    государственных органов и реализующих дополнительные
                                    общеобразовательные программы, имеющие целью подготовку
                                    несовершеннолетних обучающихся к военной или иной
                                    государственной службе.
                                </li>
                                <li>
                                    Преимущественное право зачисления в образовательные
                                    организации высшего образования, находящиеся в ведении
                                    федерального органа исполнительной власти, осуществляющего
                                    функции по выработке и реализации государственной политики и
                                    нормативно-правовому регулированию в сфере внутренних дел, и
                                    федерального органа исполнительной власти, осуществляющего
                                    функции по выработке и реализации государственной политики и
                                    нормативно-правовому регулированию в сфере деятельности войск
                                    национальной гвардии Российской Федерации, в сфере оборота
                                    оружия, в сфере частной охранной деятельности и в сфере
                                    вневедомственной охраны, при условии успешного прохождения
                                    вступительных испытаний и при прочих равных условиях
                                    предоставляется детям сотрудников органов внутренних дел
                                    Российской Федерации, имеющих общую продолжительность службы
                                    двадцать лет и более, детям граждан, проходящих службу по
                                    контракту в войсках национальной гвардии Российской Федерации
                                    и имеющих общую продолжительность службы двадцать лет и более,
                                    детям граждан, которые уволены со службы в органах внутренних
                                    дел Российской Федерации или войсках национальной гвардии
                                    Российской Федерации по достижении ими предельного возраста
                                    пребывания на службе в органах внутренних дел Российской
                                    Федерации или войсках национальной гвардии Российской
                                    Федерации, по выслуге лет, дающей право на получение пенсии,
                                    по состоянию здоровья, в связи с болезнью либо в связи с
                                    сокращением должности в органах внутренних дел Российской
                                    Федерации или войсках национальной гвардии Российской
                                    Федерации и общая продолжительность службы которых в органах
                                    внутренних дел Российской Федерации или войсках национальной
                                    гвардии Российской Федерации составляет двадцать лет и более.
                                </li>
                            </ul>
                        </p>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    );
}

export default App4;